import { render, staticRenderFns } from "./detailKesehatan.vue?vue&type=template&id=878d3372&"
import script from "./detailKesehatan.vue?vue&type=script&lang=ts&"
export * from "./detailKesehatan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports